export const sansthaExportColumns = [
	{ label: 'Sr No', key: 'index' },

	{
		label: 'Sanstha Name',
		render: (s) => s?.name || '',
	},

	{
		label: 'Community',
		render: (s) => s?.hub?.name || '',
	},

	{
		label: 'Caste',
		render: (s) => s?.caste?.name || '',
	},

	{
		label: 'Total Members',
		render: (s) => s?.users?.length || 0,
	},

	{
		label: 'Language',
		render: (s) => (Array.isArray(s?.language) ? s.language.map((l) => l.name).join(', ') : ''),
	},

	{
		label: 'Religion',
		render: (s) => s?.religion?.name || '',
	},

	{
		label: 'Admin Name',
		render: (s) => (s?.admin ? `${s.admin.firstName || ''} ${s.admin.lastName || ''}` : ''),
	},

	{
		label: 'Admin Mobile',
		render: (s) => s?.admin?.mobile || '',
	},

	{
		label: 'Sanstha Type',
		render: (s) => s?.sansthaType || '',
	},

	{
		label: 'Sanstha Act',
		render: (s) => s?.Act || '',
	},

	{
		label: 'Registration Number',
		render: (s) => s?.registrationNumber || '',
	},

	{
		label: 'Registration Date',
		render: (s) => (s?.registrationDate ? new Date(s.registrationDate).toLocaleDateString() : ''),
	},

	{
		label: 'Active',
		render: (s) => (s?.active ? 'Yes' : 'No'),
	},

	{
		label: 'Verified',
		render: (s) => (s?.verified ? 'Yes' : 'No'),
	},
]
